import styled from "styled-components";
import { Theme } from "theme";

// todo - bare dupe styling with the SeasonTable
export const SwissTeamRow = styled.tr`
  line-height: 100%;

  td {
    padding-top: 3px;
    padding-bottom: 3px;
    white-space: nowrap;
    border-bottom: ${Theme.panelContentBorder};
  }

  &:last-child {
    td {
      border-bottom: 0;
    }
  }
`;

const borderLeftCell = styled.td`
  border-left: ${Theme.panelContentBorder};
`;

export const PositionCell = styled.td`
  width: 15px;
  text-align: center;
  padding-left: ${Theme.bigPanelPaddingHorizontal};

  @media (max-width: 850px) {
    padding-left: ${Theme.smallPanelPadding};
  }
`;

export const TeamLogoCell = styled.td`
  padding-left: 5px;
  width: 24px;
  @media (max-width: 850px) {
    padding-left: 2px;
  }
`;

export const OrgLogoContainer = styled.div`
  width: 34px;
  height: 26px;

  @media (max-width: 700px) {
    width: 33px;
    height: 25px;
  }

  @media (max-width: 500px) {
    width: 28px;
    height: 24px;
  }
`;

export const TeamNameCell = styled.td`
  padding-left: 6px;
  max-width: 120px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow-x: clip;
  @media (max-width: 850px) {
    padding-left: 3px;
  }
`;

export const RecordCell = styled(borderLeftCell)`
  text-align: center;
  width: 0;
  padding: 20px;

  @media (max-width: 850px) {
    padding: 10px;
    font-size: 11pt;
  }
`;

export const WinLossRecordCell = styled(RecordCell)`
  font-weight: 500;
  background: ${Theme.tdHighlightBackground};
  color: ${Theme.tdHighlightForeground};
`;

export const DifferentialCell = styled(borderLeftCell)`
  text-align: center;
  width: 0;
  padding: 20px;

  @media (max-width: 850px) {
    padding: 10px;
    font-size: 11pt;
  }
`;

export const SwissMatchCell = styled(borderLeftCell)<{ winningTeam: boolean }>`
  cursor: pointer;

  @media (max-width: 850px) {
    font-size: 11pt;
  }
  &:hover {
    ${({ winningTeam }) => winningTeam && "background:rgba(0, 200, 0, 0.2)"}
    ${({ winningTeam }) => !winningTeam && "background: rgba(200, 0, 0, 0.2)"}
  }

  ${({ winningTeam }) => winningTeam && "background:rgba(0, 200, 0, 0.1)"}
  ${({ winningTeam }) => !winningTeam && "background: rgba(200, 0, 0, 0.1)"}
`;

export const SwissMatchTeamLogoContainer = styled.div`
  width: 26px;
  height: 26px;
  @media (max-width: 850px) {
    width: 24px;
    height: 24px;
  }
`;

export const MatchPlaceHolderCell = styled(borderLeftCell)`
  background: ghostwhite;
`;
